import React from 'react';
import { number } from 'prop-types';
import { MapStatsUtil } from '../../../utils/map_stats_util';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const CardDuration = ({ durationInMinutes }) => {
  if (!durationInMinutes) {
    return null;
  }

  let className = 'xlate-none';
  const hours = Math.floor(durationInMinutes / 60);

  if (hours >= 12) {
    // "Multi-day" can be translated while "4 h 38 m" cannot
    className = null;
  }

  return (
    <span className={className}>
      {StringConstantsMixin.strings.FILTERS.EST} {MapStatsUtil.minutesToFormattedTime(durationInMinutes, 1)}
    </span>
  );
};

CardDuration.propTypes = {
  durationInMinutes: number
};

CardDuration.defaultProps = {
  durationInMinutes: null
};

export default CardDuration;
